import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FetchData, Toast, UploadImage } from "../../customHooks/customHooks";
import {
  ASSIGN_CUSTMER,
  CREATE_CALL_URl,
  CREATE_CUSTOMER,
  CREATE_CUSTOMER_VIEW_LOG,
  CUSTOMER_HISTORY,
  CUSTOMER_PERMISSION_GET_BY_ROLE,
  CUSTOMER_PERMISSION_UPSERT,
  DELETE_CALL_URl,
  DELETE_CUSTOMER,
  GET_ALL_CUSTOMER,
  GET_Calls_HISTORY_URl,
  GET_Calls_URl,
  GET_CUSTOMER_BY_ID,
  MANAGE_Calls_VIEW_HISTORY_LOG_URl,
  MANAGE_Calls_VIEW_HISTORY_URl,
  UPDATE_CALL_URl,
  UPDATE_CUSTOMER,
  UPLOAD_FILE,
} from "../../api";

// -- Async Thunk to Get User Profile --
export const GetAllCustomer = createAsyncThunk(
  "getAllCustomer",
  async (body, { rejectWithValue }) => {
    try {
      const response = await FetchData(GET_ALL_CUSTOMER, body);

      if (!response) throw new Error("No response received");

      if (response.status === 200) {
        let { data } = response.data;
        return { status: 200, data }; // ✅ Return the actual user profile data
      } else if (response.status === 401) {
        return rejectWithValue("Unauthorized");
      } else {
        return rejectWithValue("Failed to fetch user profile");
      }
    } catch (err) {
      console.log("Error fetching user profile:", err);
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

// -- Slice --
const GetAllCustomerSlice = createSlice({
  name: "Customer",
  initialState: {
    Customer: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetAllCustomer.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetAllCustomer.fulfilled, (state, action) => {
        state.Customer = action.payload; // ✅ Store fetched profile
        state.loading = false;
      })
      .addCase(GetAllCustomer.rejected, (state, action) => {
        state.error = action.payload || action.error.message;
        state.loading = false;
      });
  },
});

const GetCallDetialsSlice = createSlice({
  name: "Call Details ",
  initialState: {
    Call: "",
  },
  reducers: {
    setCallDetials: (state, action) => {
      state.Call = action.payload;
    },
  },
});

export const GetCustomerById = createAsyncThunk(
  "getCoustomerById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await FetchData(GET_CUSTOMER_BY_ID, { CustomerID: id });

      if (!response) throw new Error("No response received");

      if (response.status === 200) {
        let { data } = response.data;
        return { status: 200, data };
      } else if (response.status === 401) {
        return rejectWithValue("Unauthorized");
      } else {
        return rejectWithValue("Failed to fetch user profile");
      }
    } catch (err) {
      console.log("Error fetching user profile:", err);
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

export const CreateCustomer = createAsyncThunk(
  "CreateCall",
  async (body, { rejectWithValue }) => {
    try {
      const response = await FetchData(CREATE_CUSTOMER, body);

      if (!response) throw new Error("No response received");

      if (response.status === 200) {
        Toast("success", response?.data?.apiStatus?.statusMessage);
        return "ok";
      } else if (response.status === 401) {
        return { status: response?.status };
      } else {
        return { status: response?.status };
      }
    } catch (err) {
      console.log("Error fetching user profile:", err);
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

export const UpdateCustomer = createAsyncThunk(
  "updatemenu",
  async (body, { rejectWithValue }) => {
    try {
      const response = await FetchData(UPDATE_CUSTOMER, body);

      if (!response) throw new Error("No response received");

      if (response.status === 200) {
        Toast("success", response?.data?.apiStatus?.statusMessage);

        return "ok";
      } else if (response.status === 401) {
        return { status: response?.status };
      } else {
        return { status: response?.status };
        return rejectWithValue("Failed to fetch user profile");
      }
    } catch (err) {
      console.log("Error fetching user profile:", err);
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

export const DeleteCustomer = createAsyncThunk(
  "deletMenu",
  async (id, { rejectWithValue }) => {
    try {
      const response = await FetchData(DELETE_CUSTOMER, { CustomerID: id });

      if (!response) throw new Error("No response received");

      if (response.status === 200) {
        // Toast('success', response?.data?.apiStatus?.statusMessage)

        return "ok";
      } else if (response.status === 401) {
        return { status: response?.status };
      } else {
        return { status: response?.status };
      }
    } catch (err) {
      console.log("Error fetching user profile:", err);
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

export const ManageCustomerViewersHistory = createAsyncThunk(
  "CallHistoryView",
  async (id, { rejectWithValue }) => {
    try {
      const response = await FetchData(MANAGE_Calls_VIEW_HISTORY_URl, {
        CustomerID: id,
      });

      if (!response) throw new Error("No response received");

      if (response.status === 200) {
        // Toast('success', response?.data?.apiStatus?.statusMessage)

        let { data } = response.data;
        // console.log(data);
        return { status: 200, viewers: data };
      } else if (response.status === 401) {
        return rejectWithValue("Unauthorized");
      } else {
        return rejectWithValue("Failed to fetch user profile");
      }
    } catch (err) {
      console.log("Error fetching user profile:", err);
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

export const ManageCustomerHistoryLog = createAsyncThunk(
  "ManageCallLog",
  async (id, { rejectWithValue }) => {
    try {
      const response = await FetchData(CREATE_CUSTOMER_VIEW_LOG, {
        CustomerID: id,
      });

      if (!response) throw new Error("No response received");

      if (response.status === 200) {
        return "ok";
      } else if (response.status === 401) {
        return rejectWithValue("Unauthorized");
      } else {
        return rejectWithValue("Failed to fetch user profile");
      }
    } catch (err) {
      console.log("Error fetching user profile:", err);
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

// AssignCustomerById -----
export const AssignCustomerById = createAsyncThunk(
  "AssignCustomerById",
  async (body, { rejectWithValue }) => {
    try {
      const response = await FetchData(ASSIGN_CUSTMER, body);

      if (!response) throw new Error("No response received");

      if (response.status === 200) {
        Toast("success", response?.data?.apiStatus?.statusMessage);
        return { status: response.status, Message: "ok" };
      } else if (response.status === 401) {
        return { status: response.status };
      } else {
        return { status: response.status };
      }
    } catch (err) {
      console.log("Error fetching user profile:", err);
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

// -- AgetCustomerHistory --
export const GetCustomerHistory = createAsyncThunk(
  "getCustomerHistory",
  async (body, { rejectWithValue }) => {
    try {
      const response = await FetchData(CUSTOMER_HISTORY, { CustomerID: body });

      if (!response) throw new Error("No response received");

      if (response.status === 200) {
        let { data } = response.data;
        // console.log(data);
        return { status: 200, data }; // ✅ Return the actual user profile data
      } else if (response.status === 401) {
        return rejectWithValue("Unauthorized");
      } else {
        return rejectWithValue("Failed to fetch user profile");
      }
    } catch (err) {
      console.log("Error fetching user profile:", err);
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

export const AddAtchmentFile = createAsyncThunk(
  "addAtechMent",
  async (body, { rejectWithValue }) => {
    let formData = new FormData();
    formData.append("file", body);

    try {
      const response = await UploadImage(UPLOAD_FILE, formData);

      if (!response) throw new Error("No response received");

      if (response.status === 200) {
        let { filePath } = response?.data;
        return { Status: 200, FilePath: filePath }; // ✅ Return the actual user profile data
      } else if (response.status === 401) {
        return rejectWithValue("Unauthorized");
      } else {
        return rejectWithValue("Failed to fetch user profile");
      }
    } catch (err) {
      console.log("Error fetching user profile:", err);
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

// -- AgetCustomerHistory --
export const GetCustomerPermission = createAsyncThunk(
  "getCustomerHistory",
  async (id, { rejectWithValue }) => {
    try {
      const response = await FetchData(CUSTOMER_PERMISSION_GET_BY_ROLE, {
        RoleID: id,
      });

      if (!response) throw new Error("No response received");

      if (response.status === 200) {
        let { data } = response.data;
        return { status: 200, data }; // ✅ Return the actual user profile data
      } else if (response.status === 401) {
        return rejectWithValue("Unauthorized");
      } else {
        return { status: 404 };
      }
    } catch (err) {
      console.log("Error fetching user profile:", err);
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

// -- createUPdateCustomerPerMission --
export const CreateUpdateCustomerPermission = createAsyncThunk(
  "createUPdateCustomerPerMission",
  async (body, { rejectWithValue }) => {
    try {
      const response = await FetchData(CUSTOMER_PERMISSION_UPSERT, body);

      if (!response) throw new Error("No response received");

      if (response.status === 200) {
        Toast("success", response?.data?.apiStatus?.statusMessage);
        // let { data } = response.data
        // console.log(data);
        return "ok"; // ✅ Return the actual user profile data
      } else if (response.status === 401) {
        return rejectWithValue("Unauthorized");
      } else {
        return rejectWithValue("Failed to fetch user profile");
      }
    } catch (err) {
      console.log("Error fetching user profile:", err);
      return rejectWithValue(err.message || "Something went wrong");
    }
  }
);

const SearchCustomerSlice = createSlice({
  name: "search",
  initialState : {
    searchKey : ''
  },
  reducers: {
    searchCustomer : (state, action) =>  {
        state.searchKey = action.payload || ""
    },
  },
});




export const { searchCustomer } = SearchCustomerSlice.actions;
export const { setCallDetials } = GetCallDetialsSlice.actions;
export { GetAllCustomerSlice, GetCallDetialsSlice, SearchCustomerSlice };
